import React from 'react';
import AddGeneralSettingComponent from '../../../Components/GeneralSetting/AddGeneralSetting';

export default function AddGeneralSetting() {
    return (
        <div className='page-body'>
            <AddGeneralSettingComponent />
        </div>
    );
}